export default __webpack_public_path__ + "static/logo-e3aec273f98787f0d194a22af3b91726.svg";